import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

export default function Post({
  title,
  thumbUrl,
  date,
  btnText,
  href,
  socialShare,
  variant,
  description,
}) {
  return (
    <div
      className={`cs_post cs_style_1 ${variant}`}
      style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
    >
      <Link
        to={href}
        className='cs_post_thumb cs_view_mouse'
        style={{ height: '280px', overflow: 'hidden' }}
      >
        <img
          src={thumbUrl}
          alt={title}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Link>
      <div
        className='cs_post_info'
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          padding: '20px 24px 24px',
        }}
      >
        <div style={{ flex: 1 }}>
          <div className='cs_post_meta' style={{ marginBottom: '4px' }}>
            <div className='cs_posted_by'>{date}</div>
            {/* {socialShare && (
              <div className="cs_post_social">
                <Link to="/" className="cs_center rounded-circle">
                  <Icon icon="fa-brands:linkedin-in" />
                </Link>
                <Link to="/" className="cs_center rounded-circle">
                  <Icon icon="fa-brands:facebook-f" />
                </Link>
                <Link to="/" className="cs_center rounded-circle">
                  <Icon icon="fa-brands:twitter" />
                </Link>
              </div>
            )} */}
          </div>
          <h2 className='cs_post_title cs_semibold cs_fs_32'>
            <Link to={href}>{title}</Link>
          </h2>
          {description && (
            <p
              style={{
                margin: '8px 0 0',
                color: '#666',
                fontSize: '16px',
                lineHeight: '1.5',
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                marginTop: -10,
              }}
            >
              {description}
            </p>
          )}
        </div>
        {btnText && (
          <div className='cs_heading_color cs_medium'>
            <Link to={href} className='cs_post_btn'>
              {btnText}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
